import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "row flex-center py-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-7" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "",
      href: "https://www.latudio.com"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "me-2",
        src: _imports_0,
        alt: "latudio-logo",
        width: "250",
        height: "100"
      })
    ])
  ])
], -1)
const _hoisted_3 = { class: "row justify-content-center align-items-center" }
const _hoisted_4 = { class: "col-sm-12 col-md-8 col-lg-6 col-xl-5 col-xxl-4 align-self-center" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body p-4 p-sm-5" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "text-danger text-sm" }
const _hoisted_10 = { class: "mb-8" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "text-danger text-sm" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              id: "login-form",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.processForm && _ctx.processForm(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  id: "authentication-email",
                  class: "form-control",
                  type: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.body.email) = $event)),
                  placeholder: _ctx.$t('authentication.email'),
                  required: ""
                }, null, 8, _hoisted_8), [
                  [_vModelText, _ctx.form.body.email]
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.errors.email), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-primary d-block w-100 mt-3",
                  type: "submit",
                  name: "submit",
                  textContent: _toDisplayString('Send Code')
                }, null, 8, _hoisted_11)
              ])
            ], 32),
            _createElementVNode("form", {
              id: "login-form",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.processFormCode && _ctx.processFormCode(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  id: "authentication-email",
                  class: "form-control",
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.body.email) = $event)),
                  placeholder: 'Enter Code',
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.body.email]
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.errors.email), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: "btn btn-primary d-block w-100 mt-3",
                  type: "submit",
                  name: "submit",
                  textContent: _toDisplayString('Continue')
                }, null, 8, _hoisted_15)
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}